import React, { useState, useEffect } from 'react';
import { styled } from '../../../stitches.config';
import Cookies from "cookies-js"

import Box from '../Box'
import Timer from '../../common/Timer'

import clock from '../../../assets/img/brid_clock.svg'

export default props => {
    const [voted, setVoted] = useState(null)
    const [percentage, setPercentage] = useState(null)
    const [hasCookie, setHasCookie] = useState(false)

    useEffect(() => {
        const value = Cookies.get("_brid");
        if (typeof value === "string") {
            const [blockID, articleID] = value.split(".");
            setHasCookie(true)
            if (blockID === props.settings.uID) {
                setVoted(articleID)
            }
        }
    }, [])

    return (
        <section className="container">
            <Wrap className="row">
                <div className="col-xs-12 col-md-3">
                    <Box {...props}
                        id="b1"
                        type="ABridTileSmall1"
                        settings={props.settings.b1}
                        classes=""
                        secondArticleID={props.settings.b2?.articleID}
                        thirdArticleID={props.settings.b3?.articleID}
                        imageHeight={371}
                        voted={voted}
                        setVoted={setVoted}
                        percentage={percentage}
                        setPercentage={setPercentage}
                        uID={props.settings.uID}
                        hasCookie={hasCookie}
                        votingResult={props.settings.votingResult}
                    />
                </div>
                <div className="col-xs-12 col-md-3">
                    <Box {...props}
                        id="b2"
                        type="ABridTileSmall1"
                        settings={props.settings.b2}
                        classes=""
                        secondArticleID={props.settings.b1?.articleID}
                        thirdArticleID={props.settings.b3?.articleID}
                        imageHeight={371}
                        voted={voted}
                        setVoted={setVoted}
                        percentage={percentage}
                        setPercentage={setPercentage}
                        uID={props.settings.uID}
                        hasCookie={hasCookie}
                        votingResult={props.settings.votingResult}
                    />
                </div>
                <div className="col-xs-12 col-md-3">
                    <Box {...props}
                        id="b3"
                        type="ABridTileSmall1"
                        settings={props.settings.b3}
                        classes=""
                        secondArticleID={props.settings.b1?.articleID}
                        thirdArticleID={props.settings.b2?.articleID}
                        imageHeight={371}
                        voted={voted}
                        setVoted={setVoted}
                        percentage={percentage}
                        setPercentage={setPercentage}
                        uID={props.settings.uID}
                        hasCookie={hasCookie}
                        votingResult={props.settings.votingResult}
                    />
                </div>
                <TimerWrapper className="col-xs-12 col-md-3">
                    <img src={clock} alt="" />

                    <p>Do końca głosowania pozostało:</p>

                    <div><Box {...props} id="b4" type="ABridTimer" settings={props.settings.b4} classes="" />
                        {/* <Timer finishTime={props.settings.b4?.finishTime} /> */}
                    </div>
                </TimerWrapper>
            </Wrap>
        </section>
    );
}

const TimerWrapper = styled("div", {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    color: "#272424",
    "img": {
        marginTop: "76px"
    },
    "p": {
        margin: "10px",
        fontSize: "16px"
    },
    "div": {
        fontSize: "32px"
    },
});

const Wrap = styled("div", {
    display: "flex",
    flexDirection: "column",
    "& > div": {
        "&:nth-of-type(1)": { order: 2 },
        "&:nth-of-type(2)": { order: 3 },
        "&:nth-of-type(3)": { order: 4 },
        "&:nth-of-type(4)": { order: 1 }
    },
    "@media (min-width:992px)": {
        display: "block"
    }
});